// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"79":"e1bff7cf","187":"644bc5b3","410":"9cd547fe","629":"cdaf4574","888":"0d575785","995":"643a286a"}[chunkId] + ".chunk.css";
};